import * as React from 'react';
import { connect } from 'react-redux';
import { HashRouter, Route, RouteComponentProps, Switch } from 'react-router-dom';
import { AppUrls } from '../AppUrls';
import { appUrlsSelector } from '../selectors/AppUrlsSelector';
import { AppState } from '../state/AppState';
import { Main } from './Main';

// eslint-disable-next-line prettier/prettier
export interface AppRouterOwnProps { }

export type AppRouterProps = AppRouterOwnProps & AppRouterStateProps;

export function AppRouter(props: AppRouterProps): JSX.Element {
  return (
    <HashRouter key={'root-space-router-search'}>
      <Switch>
        <Route
          path={props.urls.searchPath()}
          render={(routeProps: RouteComponentProps) => (
            <Main routeLocationSearch={routeProps.location.search} routeLocationPathName={routeProps.location.pathname} />
          )}
        />
      </Switch>
    </HashRouter>
  );
}

export interface AppRouterStateProps {
  readonly urls: AppUrls;
}

const mapStateToProps = (state: AppState) => ({
  previousUrl: null,
  urls: appUrlsSelector(),
});

export const ConnectedAppRouter: React.ComponentClass<AppRouterOwnProps> = connect(mapStateToProps)(AppRouter);
